/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';
import { FieldArray, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import ElearningSemester from './ElearningSemester';
import ElearningHours from './ElearningHours';
import ElearningHoursPercent from './ElearningHoursPercent';
import ElearningCompletion from './ElearningCompletion';
import ElearningUnitsPercent from './ElearningUnitsPercent';
import ElearningCourse from './ElearningCourse';
import FieldResources from './ElearningRessources';

const messages = defineMessages({
  course: {
    id: 'Elearning.course',
    defaultMessage: 'Course',
  },
  elearningTarget: {
    id: 'Elearning.completion',
    defaultMessage: 'Completion',
  },
  ressources: {
    id: 'Elearning.ressources',
    defaultMessage: 'Ressources',
  },
  program: {
    id: 'Elearning.program',
    defaultMessage: 'Program',
  },
  evaluation: {
    id: 'Elearning.evaluation',
    defaultMessage: 'Evaluation',
  },
  resources: {
    id: 'Elearning.resources',
    defaultMessage: 'Elearning Resources',
  },
});

const Elearning = (props) => {
  const { dataform, intl } = props;

  const [semester] = useState();

  return (
    <div>
      <Container className="group-creation-container-centered">
        <Col className="group-creation-card-elearning">
          <h3>E-learning</h3>
          <ElearningCourse />
          <Row>
            <Col md={2}>
              <ElearningHours />
            </Col>
            <Col md={2}>
              <ElearningHoursPercent />
            </Col>
            <Col md={2}>
              <ElearningCompletion />
            </Col>
            <Col md={2}>
              <ElearningUnitsPercent />
            </Col>
            <Col md={2}>
              <ElearningSemester semester={semester} />
            </Col>
          </Row>
        </Col>
      </Container>
      <Container className="group-creation-container-centered">
        <Col className="group-creation-card-elearning">
          <h3>
            {' '}
            {intl.formatMessage(messages.resources)}
          </h3>
          <Row>
            <Col md={12}>
              <FieldArray
                name="elearningResources"
                component={FieldResources}
                tabval="3"
              >
                {dataform}
              </FieldArray>
            </Col>
          </Row>
        </Col>
      </Container>
    </div>
  );
};

Elearning.propTypes = {
  intl: PropTypes.object.isRequired,
  dataform: PropTypes.any.isRequired,
};

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return { initialValues: state.group.selectedGroup, form: name, dataform };
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
})(injectIntl(Elearning));

const NewconnectedGroupForm = connect(mapStateToProps, {})(connectedGroupForm);

export default NewconnectedGroupForm;
